import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { PerformanceInsightsPage } from '@confluence/performance-insights/entry-points/PerformanceInsightsPage.ts';
import { PERFORMANCE_INSIGHTS_NETWORK_SPEED } from '@confluence/named-routes/entry-points/routes.ts';

export const PerformanceInsightsRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS({ name, params: { tab } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				attributes: {
					tab: string;
				};
			};
			pageState: {
				routeName: string;
				tab: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <PerformanceInsightsPage />;

PerformanceInsightsRoute.NAVIGATION_PARAMS = ({
	name,
	params: { tab },
	query,
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			attributes: {
				tab: string;
			};
		};
		pageState: {
			routeName: string;
			tab: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => {
	const legacyTab = Array.isArray(query.tab) ? query.tab[0] : query.tab;
	const resolvedTab =
		name === PERFORMANCE_INSIGHTS_NETWORK_SPEED.name || tab === 'user-setup'
			? 'user-setup'
			: tab === 'overview' || (tab === undefined && legacyTab === 'overview')
				? 'overview'
				: tab === 'content-metrics' || (tab === undefined && legacyTab === 'content-metrics')
					? 'content-metrics'
					: 'load-times';

	return {
		Screen: {
			screenEvent: {
				name: 'performanceInsightsScreen',
				attributes: {
					tab: resolvedTab,
				},
			},
			pageState: {
				routeName: name,
				tab: resolvedTab,
			},
		},
		MainLayout: {
			navView: ADMIN_HOME_ID,
		},
	};
};
